export interface IHistoryState {
	claimHistory: IHistoryItem[];
}

export interface IHistoryItem {
	isNew?: boolean;
	attachmentType:
		| 'PRESCRIPTION'
		| 'RECEIPT'
		| 'OTHER'
		| 'COMPLAINT'
		| 'FRAUD'
		| 'RETURN'
		| 'BILLING';
	createdBy?: {
		memberFirstName: string;
		memberLastName: string;
		memberRole: string;
		memberRoleLabel: string;
	};
	denialArticle: string;
	denialNumArticle: string;
	fileName: string;
	groupCode: string;
	groupLabel: string;
	id: number;
	internalNote: string;
	label: string;
	lastInsert: string;
	logoHistory: string;
	name: string;
	reasonCode: string;
	reasonCodeLabel: string;
	typeHistory: keyof typeof HISTORY_TYPES;
	uuid: string;
	statusCode?: string;
	statusLabel?: string;
	typeCode?: string;
	typeLabel?: string;
	outcomeCode?: string;
	outcomeLabel?: string;
	investigationStatusCode?: string;
	investigationStatusLabel?: string;
}

export enum HISTORY_TYPES {
	CLAIM = 'CLAIM',
	FRAUD = 'FRAUD',
	COMPLAINT = 'COMPLAINT',
	ATTACHMENT = 'ATTACHMENT',
	BILLING = 'BILLING',
	RETURN = 'RETURN',
}

export enum HISTORY_ACTORS {
	PROVIDER = 'PROVIDER',
	ADMIN = 'ADMIN',
}
